import { CanopyLogo } from '@web/components/CanopyLogo'

export function CanopyMark({ size = 34 }: { size?: number }) {
  return <CanopyLogo size={size} />
}
